exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-perfect-scrollbar .ps:hover > .ps__scrollbar-y-rail {\n  opacity: 1;\n}\n.custom-perfect-scrollbar .ps__scrollbar-y-rail {\n  background-color: #eee !important;\n  border-radius: 8px !important;\n  width: 15px !important;\n  right: 5px;\n  opacity: 1;\n}\n.custom-perfect-scrollbar .ps__scrollbar-y {\n  border-radius: 8px !important;\n  width: 15px !important;\n  right: 0 !important;\n}\n", ""]);

// exports
